var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{attrs:{"dark":"","fixed":"","bottom":"","right":"","fab":""},on:{"click":() => (_vm.$vuetify.theme.dark = !_vm.$vuetify.theme.dark)}},[(!_vm.$vuetify.theme.dark)?_c('v-icon',[_vm._v("mdi-weather-night")]):_c('v-icon',[_vm._v("mdi-white-balance-sunny")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }